import { render } from "./CookieConsent.vue?vue&type=template&id=35ff2486&scoped=true"
import script from "./CookieConsent.vue?vue&type=script&lang=js"
export * from "./CookieConsent.vue?vue&type=script&lang=js"

import "./CookieConsent.vue?vue&type=style&index=0&id=35ff2486&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ff2486"]])

export default __exports__